import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DemokratiewerkstattCategoryService} from "../../../services/demokratiewerkstatt-category.service";
import {DemokratiewerkstattCategory} from "../../../models/demokratiewerkstatt.model";

@Component({
  selector: 'app-demokratiewerkstatt-category-edit',
  templateUrl: './demokratiewerkstatt-category-edit.component.html',
  styleUrls: ['./demokratiewerkstatt-category-edit.component.css']
})
export class DemokratiewerkstattCategoryEditComponent implements OnInit {
  public demokratiewerkstattCategoryForm: FormGroup;
  public showSpinner: boolean = false;
  private demokratiewerkstattCategory: DemokratiewerkstattCategory;

  constructor(
    private _fb: FormBuilder,
    private _demokratiewerkstattCategoryService: DemokratiewerkstattCategoryService,
    private _router: Router,
    private _route: ActivatedRoute) {
  }

  ngOnInit(): void {
    const id = +this._route.snapshot.params['id'];
    window.scrollTo(0, 0);
    this._demokratiewerkstattCategoryService.getDemokratiewerkstattCategory(id)
      .subscribe(
        (response: DemokratiewerkstattCategory) => {
          this.demokratiewerkstattCategory = response;
          this.initForm(this.demokratiewerkstattCategory);
        }
      );
  }

  public submitForm(): void {
    const formValue = this.demokratiewerkstattCategoryForm.value;
    this.demokratiewerkstattCategory.name = formValue['name'];
    this.demokratiewerkstattCategory.description = formValue['description'];

    this.showSpinner = true;

    this._demokratiewerkstattCategoryService.editProjectCategory(this.demokratiewerkstattCategory.id ?? 0, this.demokratiewerkstattCategory).subscribe(
      (response: DemokratiewerkstattCategory) => {
        this._router.navigate([`/project-category/${response.id}`])
        this.showSpinner = false;
      },
      (error) => {
        console.error(`An error occured: ${error.message}`);
      }
    );
  }

  public cancelEdit(): void {
    this._router.navigateByUrl('/project-category/list');
  }

  private initForm(demokratiewerkstattCategory: DemokratiewerkstattCategory) {
    this.demokratiewerkstattCategoryForm = this._fb.group({
      name: [demokratiewerkstattCategory.name, Validators.required],
      description: [demokratiewerkstattCategory.description],
    });
  }
}
